import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import NotificacoesLayer from "../components/NotificacoesLayer";
import { useTranslation } from "../i18n/I18nContext";

const NotificacoesEstudantesPage = () => {
  const { t } = useTranslation();
  return (
    <MasterLayout>
      <Breadcrumb title={t("notificacoes.breadcrumb")} />
      <NotificacoesLayer />
    </MasterLayout>
  );
};

export default NotificacoesEstudantesPage;
